function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.01,
    height: 2.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.45166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 1.355
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.71,
    width: 15.01,
    height: 10.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 8.030000000000001
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.35,
    width: 15.01,
    height: 33.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5016666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 29.97
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.59,
    width: 15.01,
    height: 37.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6677777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 65.185
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.79,
    width: 15.01,
    height: 39.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.144285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 103.48
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.16,
    width: 15.01,
    height: 44.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.87625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 145.64
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168.13,
    width: 15.01,
    height: 59.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5016666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 197.745
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 227.36,
    width: 15.01,
    height: 65.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 260.27500000000003
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.18,
    width: 15.01,
    height: 68.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 327.43
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.69,
    width: 15.01,
    height: 72.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 398.145
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 434.6,
    width: 15.01,
    height: 77.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5016666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 473.34000000000003
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512.09,
    width: 15.01,
    height: 93.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6677777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 558.98
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 605.86,
    width: 15.01,
    height: 94.14,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5016666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.505,
    y: 652.9300000000001
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 0,
    width: 31.87,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.945,
    y: 22.475
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.88,
    y: 0,
    width: 33.19,
    height: 44.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6877777777777774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.475,
    y: 22.475
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.07,
    y: 0,
    width: 34.22,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.17999999999999,
    y: 22.475
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.29,
    y: 0,
    width: 34.65,
    height: 44.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7749999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.615,
    y: 22.475
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.94,
    y: 0,
    width: 35.54,
    height: 44.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.71,
    y: 22.475
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.48,
    y: 0,
    width: 36.38,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.276000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.67,
    y: 22.475
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.86,
    y: 0,
    width: 37.96,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.326666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.84,
    y: 22.475
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.82,
    y: 0,
    width: 39.63,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.635,
    y: 22.475
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 0,
    width: 49.11,
    height: 44.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.015,
    y: 22.475
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.57,
    y: 0,
    width: 52.22,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.68,
    y: 22.475
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.78,
    y: 0,
    width: 57.1,
    height: 44.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.33,
    y: 22.475
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.89,
    y: 0,
    width: 58.87,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.325,
    y: 22.475
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.76,
    y: 0,
    width: 59.99,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.755,
    y: 22.475
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.75,
    y: 0,
    width: 61.09,
    height: 44.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.295,
    y: 22.475
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.84,
    y: 0,
    width: 63.16,
    height: 44.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.4200000000001,
    y: 22.475
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 44.95,
    width: 58.16,
    height: 50.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 70.37
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 95.78,
    width: 58.16,
    height: 56.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 123.84
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 151.9,
    width: 58.16,
    height: 59.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.877333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 181.815
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 211.73,
    width: 58.16,
    height: 60.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.308571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 242.125
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 272.52,
    width: 58.16,
    height: 62.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 303.96
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 335.4,
    width: 58.16,
    height: 62.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.462222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 366.87
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 398.34,
    width: 58.16,
    height: 67.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 432.18499999999995
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 466.03,
    width: 58.16,
    height: 72.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 502.465
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 538.9,
    width: 58.16,
    height: 79.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 578.7049999999999
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.01,
    y: 618.51,
    width: 58.16,
    height: 81.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.089999999999996,
    y: 659.255
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 44.95,
    width: 63.63,
    height: 74.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.995,
    y: 82.42
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.81,
    y: 44.95,
    width: 68.1,
    height: 74.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.86,
    y: 82.42
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.91,
    y: 44.95,
    width: 68.48,
    height: 74.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.267692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.15,
    y: 82.42
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.38,
    y: 44.95,
    width: 74,
    height: 74.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.38,
    y: 82.42
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.38,
    y: 44.95,
    width: 76.44,
    height: 74.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.6,
    y: 82.42
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.83,
    y: 44.95,
    width: 85.1,
    height: 74.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.38,
    y: 82.42
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.93,
    y: 44.95,
    width: 89.21,
    height: 74.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.326666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.535,
    y: 82.42
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.14,
    y: 44.95,
    width: 101.86,
    height: 74.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.0699999999999,
    y: 82.42
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 119.89,
    width: 105.52,
    height: 74.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 157.01
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 194.13,
    width: 105.52,
    height: 87.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 237.675
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 281.22,
    width: 105.52,
    height: 89.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.961666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 326.105
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 371,
    width: 105.52,
    height: 95.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.726363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 418.995
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 466.98,
    width: 105.52,
    height: 109.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5371428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 521.6700000000001
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 576.36,
    width: 105.52,
    height: 123.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.552
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94,
    y: 638.1800000000001
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.69,
    y: 119.89,
    width: 152.07,
    height: 91.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.725,
    y: 165.835
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.77,
    y: 119.89,
    width: 174.33,
    height: 91.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.353636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.935,
    y: 165.835
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.1,
    y: 119.89,
    width: 194.9,
    height: 91.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.5500000000001,
    y: 165.835
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.69,
    y: 211.78,
    width: 252.3,
    height: 198.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.34714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.84000000000003,
    y: 310.995
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.69,
    y: 410.21,
    width: 252.3,
    height: 289.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.407692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.84000000000003,
    y: 555.105
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.99,
    y: 211.78,
    width: 269.01,
    height: 488.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.455454545454543
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 565.495,
    y: 455.89
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1916);
export default __webpack_public_path__ + "static/media/1916.6b33fa0e9911c0706900a5d29665d612.svg";
export { ForwardRef as ReactComponent };